export default class GeneratePeriodRent {
    constructor() {
        this.id = "";
        this.typePerid = 0;
        this.multiplier = 1;
        this.startDateHour = "";
    }
}